// @ts-ignore
import LoaderSVG from "~/assets/svg/loader.svg?react";
import * as S from "./styles";

type Props = { fullWidth?: boolean; isFixed?: boolean; color?: string };

const Loader = ({ fullWidth, isFixed = true, color }: Props) => {
  return (
    <S.LoaderContainer fullWidth={fullWidth} isFixed={isFixed} color={color}>
      <LoaderSVG />
    </S.LoaderContainer>
  );
};

export default Loader;
